import { invokeApi } from '@/common/invokeApi/invokeApi';

import { Reviewer } from '../PatientWorkQueue.types';

export const fetchReviewers = async () =>
  await invokeApi<Reviewer[]>({
    path: '/users/teammates/abilities/reviewers',
  });
